module.exports = __webpack_public_path__ + "img/about-us-img.60bd8ac9.jpg";